import { DocumentBlock } from "@entities/journal";
import "./section-fourth-violation-documents.scss";

interface Document {
  id?: string;
  fileName?: string;
  name?: string;
  file_id?: string;
}

interface SectionFourthViolationDocumentsProps {
  violationDocuments?: Document[];
}

export const SectionFourthViolationDocuments = ({
  violationDocuments = [],
}: SectionFourthViolationDocumentsProps) => {
  if (violationDocuments.length === 0) {
    return null;
  }

  return (
    <div className="section-fourth-violation-documents">
      <div className="section-fourth-violation-documents__section">
        <div className="section-fourth-violation-documents__title">
          Документы, подтверждающие факт нарушения(необязательно)
        </div>

        <div className="section-fourth-violation-documents__list">
          {violationDocuments.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.file_id}
              title="Дополнительные файлы"
              fileName={doc.fileName || doc.name || "document.pdf"}
              fileId={doc.file_id}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
